import _ from 'lodash'

function findServiceWithCategoryByServiceID(state, serviceID, categoryId = null) {
  const SERVICE_CATEGORIES = state.serviceCategories
  const SERVICE_ID = parseInt(serviceID)
  const result = { category: void 0, service: void 0 }
  if (!_.isNull(categoryId)) {
    const CATEGORY_ID = parseInt(categoryId)
    const SERVICE_CATEGORY = _.find(SERVICE_CATEGORIES, category => {
      return category.id === CATEGORY_ID
    })
    const SERVICES_ARRAY = SERVICE_CATEGORY.services

    result.service = _.find(SERVICES_ARRAY, service => {
      return service.id === SERVICE_ID
    })
    result.category = SERVICE_CATEGORY
    return result
  } else {
    _.some(SERVICE_CATEGORIES, category => {
      return _.some(category.services, service => {
        if (service.id === SERVICE_ID) {
          result.service = service
          result.category = category
          return true
        }
        return false
      })
    })
    return result
  }
}

export default {
  setServiceCategories(state, serviceCategories) {
    state.serviceCategories = serviceCategories
  },
  setServiceCategory(state, value) {
    state.serviceCategory = value
  },
  setServiceWithWorkplaces(state, value) {
    state.serviceWithWorkplaces = value
  },
  setServiceCategoryField(state, { field, fieldValue }) {
    if (state.serviceCategory) {
      state.serviceCategory = {
        ...state.serviceCategory,
        [field]: fieldValue,
      }
    }
  },
  setServiceCategoryErrors(state, serviceCategoryErrors) {
    state.serviceCategoryErrors = serviceCategoryErrors
  },
  setServiceCategoryFilters(state, serviceCategoryFilters) {
    state.serviceCategoryFilters = serviceCategoryFilters
  },
  selectServiceByID(state, { category_id, id }) {
    try {
      const { service, category } = findServiceWithCategoryByServiceID(state, id, category_id)
      service.active = !service.active

      category.active = _.every(category.services, item => item.active === true)
    } catch (e) {
      console.info('Нет такой услуги или категории', id, category_id, e)
    }
  },
  checkServiceByID(state, { category_id, id }) {
    try {
      const { service, category } = findServiceWithCategoryByServiceID(state, id, category_id)
      service.active = true

      category.active = _.every(category.services, item => item.active === true)
    } catch (e) {
      console.info('Нет такой услуги или категории', id, category_id, e)
    }
  },
  uncheckServiceByID(state, { category_id, id }) {
    try {
      const { service, category } = findServiceWithCategoryByServiceID(state, id, category_id)
      service.active = false

      category.active = false
    } catch (e) {
      console.info('Нет такой услуги или категории', id, category_id, e)
    }
  },
  selectServiceCategoryByID(state, id) {
    const SERVICE_CATEGORIES = state.serviceCategories
    const SERVICE_CATEGORY = _.find(SERVICE_CATEGORIES, category => {
      return category.id === id
    })
    const SERVICES_ARRAY = SERVICE_CATEGORY.services

    SERVICE_CATEGORY.active = !SERVICE_CATEGORY.active
    const CATEGORY_ACTIVE_STATE = SERVICE_CATEGORY.active
    _.each(SERVICES_ARRAY, service => {
      service.active = CATEGORY_ACTIVE_STATE
    })
  },
  selectDefaultServicesInCategory(state, payload) {
    const ID = payload.id
    const CHECKBOX_VALUE_DEFAULT = payload.value
    const SERVICE_CATEGORIES = state.serviceCategories
    const SERVICE_CATEGORY = _.find(SERVICE_CATEGORIES, category => {
      return category.id === ID
    })
    const SERVICES_ARRAY = SERVICE_CATEGORY.services
    const PROPERTY = 'active'

    _.each(SERVICES_ARRAY, service => {
      if (service.default_service === 1) {
        service[PROPERTY] = CHECKBOX_VALUE_DEFAULT
      }
    })
    const HAS_ACTIVE_SERVICE = _.find(SERVICES_ARRAY, service => {
      return service.active === true
    })
    SERVICE_CATEGORY.active = !!HAS_ACTIVE_SERVICE
    SERVICE_CATEGORY.default_services_picked = !!HAS_ACTIVE_SERVICE
  },
  switchServiceCategoryMenu(state, _id) {
    // TODO функция нигде не используется
    const id = parseInt(_id)
    _.some(state.serviceCategories, category => {
      return _.some(category.services, service => {
        if (service.id === id) {
          service.menu = !service.menu
          return true
        }
        return false
      })
    })
  },
  updateServiceCategoryPrice(state, payload) {
    // TODO функция нигде не используется
    const id = parseInt(payload.id)
    const value = parseInt(payload.value)
    _.some(state.serviceCategories, category => {
      return _.some(category.services, service => {
        if (service.id === id) {
          service.price_actual.price = value
          return true
        }
        return false
      })
    })
  },
  updateServiceCategoryDuration(state, payload) {
    const id = parseInt(payload.id)
    const value = parseInt(payload.value)
    _.some(state.serviceCategories, category => {
      return _.some(category.services, service => {
        if (service.id === id) {
          service.duration = value
          return true
        }
        return false
      })
    })
  },
  changeServiceCategory(state, { key, value }) {
    const index = _.findIndex(state.serviceCategories, category => category.id === key)
    if (index > -1) state.serviceCategories.splice(index, 1, value)
  },
  unshiftServiceCategories(state, serviceCategory) {
    state.serviceCategories.unshift(serviceCategory)
  },
  deleteServiceCategory(state, id) {
    const index = _.findIndex(state.serviceCategories, category => category.id === id)
    if (index > -1) state.serviceCategories.splice(index, 1)
  },
  filteredGroupService(state, serviceCategories) {
    state.serviceWithoutGroups = _.map(serviceCategories, category => {
      category.services = _.filter(category.services, service => {
        return _.isEmpty(service.group)
      })
      console.log({ category })

      return category
    })
  },
  setShortServiceCategories(state, data) {
    state.shortServiceCategories = data
  },
}
